import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Tab, Tabs, useTheme } from '@mui/material';
import { useRootStore } from 'hooks/useRootStore';
import PostReviewListOf from './PostReviewListOf';
import { PostReviewScopeT } from './TeacherPostReviewListStore';

const tabs = [
  { label: '검토 대기 글', value: 'inbox' },
  { label: '나의 검토 요청글', value: 'mine' },
];

// 여기서는 지위에 따라 탭을 보여주고
// 초기 탭을 결정한다.
// 상세 피드는 PostReviewListOf가 담당한다.
const TeacherPostReviewListContainer = observer(() => {
  const userStore = useRootStore().userStore;
  const [currentTab, setCurrentTab] = useState<PostReviewScopeT>('inbox');
  const { palette } = useTheme();

  const handleTabsChange = (event: unknown, value: PostReviewScopeT): void => {
    console.log('handleTabChange', value);
    setCurrentTab(value);
  };

  useEffect(() => {
    if (userStore.myInfo && userStore.isManager === false) {
      handleTabsChange(undefined, 'mine');
    }
  }, [userStore.isManager]);

  if (userStore.isManager) {
    // 관리자/운영자는 tab을 가진다.
    return (
      <>
        <Tabs
          sx={{
            'backgroundColor': palette.background.paper,
            ' .MuiTab-root + .MuiTab-root': {
              marginLeft: '8px',
            },
          }}
          indicatorColor="primary"
          onChange={handleTabsChange}
          textColor="primary"
          value={currentTab}
          variant="fullWidth"
        >
          {tabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
        <PostReviewListOf scope={currentTab} />
      </>
    );
  } else {
    //
    return <PostReviewListOf scope="mine" />;
  }
});
export default TeacherPostReviewListContainer;
